import * as React from 'react';
import Paper from '@material-ui/core/Paper';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { useStore } from 'react-redux';
import moment from 'moment';

export default function Parcel_entry() {
  const store: any = useStore();
  const [data, SetData]: any = React.useState([]);
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
  function fetch_table_data() {
    axios
      .get(`${process.env.REACT_APP_API_SERVER}/parcels/create-stats`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        const data = res.data
          .map((stat: any) => ({
            date: moment(stat.booking_date).format('DDMMM'),
            count: Number(stat.count),
          }))
          .slice(-30);
        SetData(data);
      });
  }

  React.useEffect(() => {
    fetch_table_data();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Bar
        options={{
          responsive: true,
          plugins: {
            legend: {
              position: 'top' as const,
            },
            title: {
              display: true,
              text: 'Daily Parcel Entry',
            },
          },
        }}
        data={{
          labels: data.map((d: { date: string }) => d.date),
          datasets: [
            {
              label: '',
              data: data.map((d: { count: string }) => d.count),
              backgroundColor: '#f50057',
            },
          ],
        }}
      />
    </div>
  );
}
